angular.module('impactx.usergroups').controller('UserGroupListController', ['selectedListItems',UserGroupListController]);

function UserGroupListController(selectedListItems) {

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'EditUserGroups'
        },
        {
            label: "catalogright",
            linkFunction: getCatalogRightLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'EditUserGroups'
        }
    ];

    function getDetailLink() {
        return "usergroup/" + selectedListItems.getFirstSelectedId();
    }

    function getCatalogRightLink() {
        return "usergroup/catalogright/" + selectedListItems.getFirstSelectedId();
    }

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/usergroups/templates/usergrouplist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/usergroup/list',
        id: 'usergroups',
        mainAction: {id: "new", link: "#/usergroup/0", icon: "mdi-plus"},
        excelExport: true
    };

    this.getMeta = function() {
        return this.meta;
    };

}